// extracted by mini-css-extract-plugin
export default {"root":"style_root__CLj7R","hiddenInput":"style_hiddenInput__bg-1G","background":"style_background__lwgtR","content":"style_content__557jX","loader":"style_loader__KQpNQ"};